import { useState, useEffect } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import styles from './style.module.css';

export default function CustomProduct({ product, onUpdate, onRemove }) {

    const [name, setName] = useState(product?.name || '');
    const [count, setCount] = useState(product?.count || 1);
    const [pricePerItem, setPricePerItem] = useState(product?.pricePerItem || 0);
    const [weightPerItem, setWeightPerItem] = useState(product?.weightPerItem || 0);

    const totalPrice = count * pricePerItem;
    const totalWeight = count * weightPerItem; // Общий вес в кг

    useEffect(() => {
        onUpdate({
            ...product,
            name: name,
            count: count,
            pricePerItem: pricePerItem,
            weightPerItem: weightPerItem,
            totalPrice: totalPrice,
            totalWeight: totalWeight,
            isCustom: true
        });
    }, [name, count, pricePerItem, weightPerItem, totalPrice, totalWeight, onUpdate]);

    const handleRemove = () => {
        onRemove(product.key);
    };

    return (
        <div className={styles.customProduct}>
            <InputGroup className="mb-3">
                <Form.Control
                    type="text"
                    placeholder="Название товара"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <Form.Control
                    type="number"
                    min="1"
                    step="1"
                    placeholder="Кол-во"
                    value={count}
                    onChange={(e) => setCount(Math.max(1, parseInt(e.target.value) || 1))}
                />
                <InputGroup.Text>шт.</InputGroup.Text>
                <Form.Control
                    type="number"
                    min="0"
                    step="1"
                    placeholder="Цена за шт."
                    value={pricePerItem}
                    onChange={(e) => setPricePerItem(parseFloat(e.target.value) || 0)}
                />
                <InputGroup.Text>₽</InputGroup.Text>
                <Form.Control
                    type="number"
                    min="0"
                    step="0.001"
                    placeholder="Вес за шт."
                    value={weightPerItem}
                    onChange={(e) => setWeightPerItem(parseFloat(e.target.value) || 0)}
                />
                <InputGroup.Text>кг.</InputGroup.Text>
                <Button variant="danger" onClick={handleRemove}>
                    <MdDelete />
                </Button>
            </InputGroup>
        </div>
    );
}